import React from "react";
import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {PlanExtensionCatalogEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_catalog.entity";
import {PlanExtensionSimulateHireEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_simulate_hire.entity";
import {PageWrapper, TwoColumnGrid} from "./styled";
import ExtensionConfirmationDetails from "./extension_confirmation_details";
import ExtensionBillingSummary from "./extension_billing_summary";

type Props = {
    extension: PlanExtensionCatalogEntity;
    simulate: PlanExtensionSimulateHireEntity;
    loading: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmExtension = observer(({extension, simulate, loading, onConfirm, onCancel}: Props) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <PageWrapper background={colors.onBackground}>
            <TwoColumnGrid>
                <ExtensionConfirmationDetails
                    extension={extension}
                    simulate={simulate}
                    onCancel={onCancel}
                />
                <ExtensionBillingSummary
                    extension={extension}
                    simulate={simulate}
                    loading={loading}
                    onConfirm={onConfirm}
                />
            </TwoColumnGrid>
        </PageWrapper>
    );
});

export default ConfirmExtension;
